import { render, staticRenderFns } from "./LoginInfoPopup.vue?vue&type=template&id=12a3b554&scoped=true&"
import script from "./LoginInfoPopup.vue?vue&type=script&lang=js&"
export * from "./LoginInfoPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a3b554",
  null
  
)

export default component.exports